export default class PlayersSnippetNotFoundError extends Error {}
